import axios from 'axios';
import { client } from './client';
import interceptors from './interceptors';
import { googleApiKey } from '../config';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getLocation() {
	return client.get('/tunnel/get-location');
}

function getMaps(params) {
	return axios
		.get('https://maps.googleapis.com/maps/api/geocode/json?address='+params+'&key=' + googleApiKey)
		.then(function(response){return response.data.results[0].geometry.location});
}

export default {
	getLocation,
	getMaps
};